import React, { FC } from "react";
import isEmpty from "lodash/isEmpty";
import { useTranslation } from "react-i18next";

import { useAppSelector } from "@/redux/store";

import { selectProductSizeChart } from "../../selectors";

const SizeHeadSection: FC<{
  showProductSizeChart: (value?: any) => void;
  children?: React.ReactNode;
}> = ({ showProductSizeChart, children }) => {
  const sizeChart = useAppSelector(selectProductSizeChart);
  const isSizeChartDataAvailable = !isEmpty(sizeChart);

  const { t } = useTranslation("productDetails");

  return (
    <div className="mobile_size_head">
      <div className="select_size_with_multisize">
        <p className="select_size">{t("selectSize")}:</p>
        {children}
      </div>
      {isSizeChartDataAvailable && (
        <div className="size_guide_link" onClick={showProductSizeChart}>
          <span className="size_guide_text">{t("sizeGuide")}</span>
          <span className="arrow" />
        </div>
      )}
    </div>
  );
};

export default SizeHeadSection;
